import { YouTubeChannel } from "./youtubechannel.types";

export const youtubeChannelsMock: YouTubeChannel[] = [
  {
    id: 1,
    company: { id: 1, name: "Muzukuru" },
    name: "streaming_company",
    display_name: "Youtube Muzukuru Streaming",
    is_active: true,
    needs_reauth: true,
    client_id: "1234567890-abcdef.apps.googleusercontent.com",
    client_secret: "super-secret-value",
    refresh_token: "1//0example-refresh-token",
    access_token_preview: "ya29.a0AfH6SMB...",
    token_uri: "https://oauth2.googleapis.com/token",
    scopes: [
      "https://www.googleapis.com/auth/youtube",
      "https://www.googleapis.com/auth/youtube.force-ssl",
    ],
    token_expiry: "2026-04-07T19:32:46Z",
    created_at: "2025-12-09T07:42:00Z",
    updated_at: "2026-04-15T10:30:00Z",
    reauth_url: "/youtube-channels/1/reauthenticate",
  },
  {
    id: 2,
    company: { id: 1, name: "Muzukuru" },
    name: "funeral_company",
    display_name: "Youtube muzukuru_funeral",
    is_active: true,
    needs_reauth: false,
    client_id: "9876543210-uvwxyz.apps.googleusercontent.com",
    client_secret: "another-secret",
    refresh_token: "1//0another-refresh-token",
    access_token_preview: "ya29.a0AnotherToken...",
    token_uri: "https://oauth2.googleapis.com/token",
    scopes: ["https://www.googleapis.com/auth/youtube"],
    token_expiry: "2026-04-15T12:12:08Z",
    created_at: "2025-12-09T07:39:00Z",
    updated_at: "2026-04-15T09:10:00Z",
    reauth_url: null,
  },
];
